import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'react-bootstrap';
import Layout from '../../components/Layout/Layout';
import { MainLogo } from '../../components';

class NotFound extends Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    return (
      <Layout>
        <Container fluid>
          <Row>
            <Col role="main">
              <div className="section">
                <div style={{ textAlign: 'center ', marginTop: '10%' }}>
                  <h1>Esta página no está disponible</h1>
                  <h3>
                    Es posible que el enlace que has seguido sea incorrecto o
                    que se haya eliminado la página.
                  </h3>
                  <div>
                    <MainLogo
                      width={200}
                      style={{ padding: 20, marginTop: '5%' }}
                    />
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </Layout>
    );
  }
}
const mapStateToProps = state => {
  const { user } = state.auth;
  return {
    user
  };
};

export default connect(mapStateToProps)(NotFound);
